import { FormattedMessage } from 'react-intl'
import { Box } from '@mui/material'
import { Button, Link, Typography } from '@carto/meridian-ds/components'
import Loader from 'features/common/ui/utils/Loader'
import CancelIcon from 'assets/icons/icon-navigation-cancel.svg?react'
import { RequestStatus } from 'features/common'
import HubspotSuccessMessage from './HubspotSuccessMessage'

export interface HubspotFormProps {
  status: RequestStatus
  onDone?: () => void
}

export function HubspotForm({ status, onDone }: HubspotFormProps) {
  const hubspotFormHasFinished = status === RequestStatus.Fulfilled || status === RequestStatus.Rejected

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      bgcolor="white"
    >
      <Box mt={'auto'}>
        {status === RequestStatus.Pending && <Loader labelId="hubspot.form.sending" />}
        {status === RequestStatus.Fulfilled && (
          <HubspotSuccessMessage successMessage={<FormattedMessage id="hubspot.form.success" />} />
        )}
        {status === RequestStatus.Rejected && (
          <Box display="flex" flexDirection="column" alignItems="center">
            <Box mb={2}>
              <CancelIcon />
            </Box>
            <Typography align="center" variant="body2" color="textSecondary">
              <FormattedMessage id="hubspot.form.error" />
              &nbsp;
              <Link href="mailto:support@carto.com" underline="none">
                support@carto.com
              </Link>
            </Typography>
          </Box>
        )}
      </Box>
      <Box alignSelf="flex-end" mt={'auto'} mr={1} mb={1}>
        {onDone && hubspotFormHasFinished && (
          <Button color="primary" onClick={onDone}>
            <FormattedMessage id="common.button.done" />
          </Button>
        )}
      </Box>
    </Box>
  )
}
